import React from "react";
import { useHistory } from "react-router-dom";
import { FaRegEnvelope, FaRegBuilding } from "react-icons/fa";

import { Page } from "ui/components";

const HelpScreen = () => {
  const History = useHistory();
  return (
    <Page title={`Pusat Bantuan`} backTo={() => History.goBack()}>
      <div className="p-2">
        <div className="text-center mb-3">
          <div>Butuh Bantuan ?</div>
          <div>beri tahu kami bagaimana kami dapat membantu</div>
        </div>

        <div className="bg-white rounded rounded-3 mb-3">
          <div className="row p-2 align-items-center">
            <div className="col-3 text-center pe-0">
              <FaRegEnvelope size={40} color="#2f83ba" />
            </div>
            <div className="col-9">
              <div className="fw-bold" style={{ fontSize: 14 }}>
                Email Kami
              </div>
              <div>support@envio.co.id</div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded rounded-3">
          <div className="row p-2 align-items-center ">
            <div className="col-3 text-center pe-0">
              <FaRegBuilding size={40} color="#2f83ba" />
            </div>
            <div className="col-9">
              <div className="fw-bold" style={{ fontSize: 14 }}>
                Alamat
              </div>
              <div>
                Jl. Puri Kembangan No.57F, RT.11/RW.5, Kembangan Sel., Kec.
                Kembangan, Kota Jakarta Barat, Daerah Khusus Ibukota Jakarta
                11610, Indonesia
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default HelpScreen;
